import React, { useState, useEffect, useRef } from "react";
import { API_URL, getValFromLS, isFieldError } from "../helpers";
import Alert from "../components/Alert";
import Select from "../components/Select";
import Textarea from "../components/Textarea";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

function getDonation(array, donationId) {
  let donation = {};
  array.forEach((obj) => {
    if (obj.id === donationId) {
      donation = obj;
    }
  });
  return donation;
}

const Form4 = ({ update }) => {
  const [details, setDetails] = useState({
    donations: [],
  });
  const [names, setNames] = useState({
    donationSelected: {},
    text: "Thank you for your contribution to support a worthy cause near and dear to me. You are playing an important part in my fundraising efforts, and I appreciate it. You are a true champion to me. Thank you!",
  });
  const [errors, setErrors] = useState([]);
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const formElement = useRef(null);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const token = getValFromLS("friendsDash", true)
      ? getValFromLS("friendsDash", true)
      : "";

    const url = new URL(`${API_URL}/auth/friendsDashForm4Init`);
    const params = {
      token,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setDetails({ ...json });
        setAlert({});
      } else {
        setAlert({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    if (name === "donationId" && value) {
      setNames((names) => ({
        ...names,
        donationId: value,
        donationSelected: getDonation(details.donations, value),
      }));
    } else if (name === "donationId") {
      setNames((names) => ({
        ...names,
        donationId: "0",
        donationSelected: {},
      }));
    } else {
      setNames((names) => ({ ...names, [name]: value ? value : "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/auth/friendsDashForm4`);
    let formData = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "donationSelected") {
        formData.append(key, JSON.stringify(value));
      } else if (key === "proof") {
        formData.append(key, value ? "1" : "0");
      } else {
        formData.append(key, value);
      }
    });
    formData.append("token", getValFromLS("friendsDash", true));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setMsg({
          type: "success",
          text: json.text,
        });
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <form
          ref={formElement}
          method="post"
          action="/"
          onSubmit={(e) => handleSubmit(e)}
          className="well"
        >
          <h3 style={{ marginTop: "0" }}>Thank a Donor</h3>

          <p>
            Use this form to send a personalized email to a donor that donated
            to <strong>{details.charityName}</strong> under your friendraising
            account.
          </p>

          <div className="form-group">
            <Select
              name="donationId"
              label="Select Donor"
              reqd={true}
              value={""}
              options={[{ id: "", name: "--" }].concat(
                details.donations.map((donation) => {
                  return { id: donation.id, name: donation.name };
                })
              )}
              update={handleUpdate}
              error={isFieldError(errors, "donationId")}
            />
            <div className="empty" />
          </div>

          {names.donationSelected?.id && (
            <div>
              <table className="donors-table" style={{ marginBottom: "15px" }}>
                <thead>
                  <tr>
                    <td className="center" style={{ width: "10%" }}>
                      Date
                    </td>
                    <td className="left">Name</td>
                    <td className="center">Email</td>
                    <td className="center" style={{ width: "20%" }}>
                      Amount
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="center">{names.donationSelected.date}</td>
                    <td className="left">{names.donationSelected.name}</td>
                    <td className="center">{names.donationSelected.email}</td>
                    <td className="right">{names.donationSelected.amt}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          <div className="form-group one">
            <Textarea
              name="text"
              label="Message"
              reqd={true}
              value={names.text || ""}
              update={handleUpdate}
              errors={errors}
              taller={true}
            />
          </div>

          <div className="form-group checkbox" style={{ marginTop: "0" }}>
            <Checkbox
              name="proof"
              label="Check to send a proof email to yourself"
              checked={false}
              click={handleUpdate}
            />
          </div>

          <div className="msg-submit">
            {msg.type && <Msg data={msg} />}

            <div
              className={msg.type === "working" ? "hidden" : "submit-container"}
            >
              <Submit path="" left="" submit="Submit Thank You Email" />
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default Form4;
